const downloadFaq = async (pdfLink: string) => {
  try {
    const pdfFile = await fetch(pdfLink, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/pdf',
      },
    });

    const blob = await pdfFile.blob();
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = 'faq.pdf';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error('Erro ao baixar o PDF:', error);
  }
};

export { downloadFaq };
